import React from 'react';
import {
  Box,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  ZoomIn,
  ZoomOut,
  FullscreenExit,
  RotateLeft,
  RotateRight,
  DragIndicator,
  Lock,
  LockOpen,
  Home,
} from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { ZoomControlsProps } from '../../types';

interface ImageControlBarProps extends ZoomControlsProps {
  onDragStart?: (e: React.MouseEvent) => void;
}

const ImageControlBar: React.FC<ImageControlBarProps> = ({
  scale,
  isZoomLocked,
  onZoomIn,
  onZoomOut,
  onZoomInStart,
  onZoomOutStart,
  onZoomStop,
  onRotateLeft,
  onRotateRight,
  onReset,
  onToggleLock,
  onReturnHome,
  onDragStart,
  onClose,
}) => {
  return (
          <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          bgcolor: 'rgba(44, 108, 160, 0.7)',
          color: 'white',
          px: 2,
          py: 1,
          cursor: 'grab',
          '&:active': {
            cursor: 'grabbing',
          },
        }}
        onMouseDown={onDragStart}
      >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <DragIndicator fontSize="small" />
        <Box sx={{ fontSize: '0.875rem', fontWeight: 500 }}>
          Receipt Image
        </Box>
      </Box>
      
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        <Tooltip title={scale >= 5 ? 'Max zoom' : 'Zoom In (hold for continuous)'}>
          <span>
            <IconButton 
              size="small" 
              onMouseDown={onZoomInStart}
              onMouseUp={onZoomStop}
              onMouseLeave={onZoomStop}
              sx={{ color: 'white' }} 
              disabled={scale >= 5}
            >
              <ZoomIn fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title={scale <= 0.2 ? 'Min zoom' : 'Zoom Out (hold for continuous)'}>
          <span>
            <IconButton 
              size="small" 
              onMouseDown={onZoomOutStart}
              onMouseUp={onZoomStop}
              onMouseLeave={onZoomStop}
              sx={{ color: 'white' }} 
              disabled={scale <= 0.2}
            >
              <ZoomOut fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
        {/* <Tooltip title="Rotate Left">
          <IconButton size="small" onClick={onRotateLeft} sx={{ color: 'white' }}>
            <RotateLeft fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Rotate Right">
          <IconButton size="small" onClick={onRotateRight} sx={{ color: 'white' }}>
            <RotateRight fontSize="small" />
          </IconButton>
        </Tooltip> */}
        <Tooltip title="Reset">
          <IconButton size="small" onClick={onReset} sx={{ color: 'white' }}>
            <FullscreenExit fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title={isZoomLocked ? 'Unlock Zoom' : 'Lock Zoom'}>
          <IconButton size="small" onClick={onToggleLock} sx={{ color: 'white' }}>
            {isZoomLocked ? <LockOpen fontSize="small" /> : <Lock fontSize="small" />}
          </IconButton>
        </Tooltip>
        <Tooltip title="Close Receipt">
          <IconButton size="small" onClick={onClose} sx={{ color: 'white' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default ImageControlBar; 